module.exports = __webpack_public_path__ + "static/media/grayWithdrawal.cc0b620f.svg";